"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  alignment: _propTypes.default.string.isRequired,
  arrow: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  content: _propTypes.default.node.isRequired,
  contentClassName: _propTypes.default.string,
  contentVisible: _propTypes.default.bool.isRequired,
  interactionHandlers: _propTypes.default.shape({
    onClick: _propTypes.default.func.isRequired,
    onKeyDown: _propTypes.default.func.isRequired,
    onMouseEnter: _propTypes.default.func,
    onMouseLeave: _propTypes.default.func
  }).isRequired,
  placement: _propTypes.default.string.isRequired,
  position: _propTypes.default.string.isRequired,
  targetClassName: _propTypes.default.string,
  targetRole: _propTypes.default.string.isRequired,
  targetTabIndex: _propTypes.default.number.isRequired,
  useJsPositioning: _propTypes.default.bool
};
exports.propTypes = propTypes;
var defaultProps = {
  className: null,
  contentClassName: null,
  targetClassName: null,
  useJsPositioning: false
};
exports.defaultProps = defaultProps;